'use strict';

function registerEvents(events, dataLayer, state, extensions, action) {
  var logger = extensions.logger,
      offlineStorage = extensions.offlineStorage;


  var logEvents = function logEvents() {
    if (logger !== undefined && typeof logger.log === 'function') {
      logger.log.apply(logger, arguments);
    }
  };

  var pushEventsToDataLayer = function pushEventsToDataLayer(eventsToPush) {
    eventsToPush.forEach(function (eventToPush) {
      return dataLayer.push(eventToPush);
    });
    return eventsToPush;
  };

  if (offlineStorage !== undefined) {
    var isConnected = offlineStorage.isConnected(state);
    if (!isConnected) {
      offlineStorage.saveEvents(events).then(function (savedEvents) {
        logEvents(savedEvents, action, state, true, false);
      });
    } else {
      pushEventsToDataLayer(events);
      logEvents(events, action, state);
      offlineStorage.purgeEvents().then(function (oldEvents) {
        if (Array.isArray(oldEvents) && oldEvents.length > 0) {
          pushEventsToDataLayer(oldEvents);
          logEvents(oldEvents, null, null, false, true);
        }
      });
    }
  } else {
    pushEventsToDataLayer(events);
    logEvents(events, action, state);
  }
}

module.exports = registerEvents;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-gtm/lib/register-events.js
// module id = 173
// module chunks = 0